import { render, staticRenderFns } from "./VCheckButton.vue?vue&type=template&id=2558f498&scoped=true&"
import script from "./VCheckButton.vue?vue&type=script&lang=ts&"
export * from "./VCheckButton.vue?vue&type=script&lang=ts&"
import style0 from "./VCheckButton.vue?vue&type=style&index=0&id=2558f498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2558f498",
  null
  
)

export default component.exports